import React, { useEffect, useState } from "react";
import HeaderAction from "../components/HeaderAction";
import styled from "styled-components";
import Tab from "../components/Tab";
import ListProduct from "../components/ListProduct";
import { ID_PRIZE } from "../components/DefineData";
import iconBg1 from "../../../../assets/images/Event-2025/bg-icon-01.png";
import iconBg2 from "../../../../assets/images/Event-2025/bg-icon-2.png";
import { getCookie, getDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { curStateAccount, curStateMiniGame } from "../../../../Redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import bgTakePrize from "../../../../assets/images/Mini-Game/bg-take-prize-web-x2.png";
import bgTakePrizeThadingyut from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme.png";
import bgTakePrizeThadingyutPc from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/bg-take-prize-thadingyut-2025-theme-pc.png";
import bgTakePrizeNewYear from "../../../../assets/images/Mini-Game/new-year-2025/bg-take-prize.png";
import DetailProduct from "../components/DetailProduct";
import _ from "lodash";
import {
  getDataPieceCollectedMiniGame,
  setDataPopupError,
  setOpenPopupPiece,
} from "../../../../Redux/futures/mini-game/action";
import ModalNotifycation from "../../../../component/ModalNotifycation";
import { useTranslation } from "react-i18next";
import PopupCongratulaPuzzle from "../components/PopupFooter/PopupCongratulaPuzzle";
import {
  INVITE_MARQUEE_END_DATE,
  INVITE_MARQUEE_START_DATE,
  // IS_EVENT_THADINGYUT_2025_THEME,
  TYPE_DETAIL_PUZZLE_PIECE,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
import PopupCongPiece from "../components/PopupFooter/PopupCongPiece";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";
import moment from "moment";
import InviteMarquee from "../components/InviteMarquee";
import Snowfall from "react-snowfall";

export default function TakePrize({
  newYearAudioRef,
}
) {
  const selectorAccount = useSelector(curStateAccount);
  const { id } = useParams();
  const itemProductActive = id;
  const [dataAwardActive, setDataAwardActive] = useState([]);
  const [isRunout, setIsRunout] = useState(null);
  const dataMiniGame = useSelector(curStateMiniGame);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isTake, setIsTake] = useState(true);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
  const maxSnowCountMobile = useMediaQuery(`(max-width: 576px)`) ? 300 : 1000;
  const [showInviteMarquee, setShowInviteMarquee] = React.useState(false);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  useEffect(() => {
    const checkAndUpdateMarquee = () => {
      const now = moment();
      const shouldShow = now.isBetween(
        INVITE_MARQUEE_START_DATE,
        INVITE_MARQUEE_END_DATE
      );
      setShowInviteMarquee(shouldShow);
    };

    checkAndUpdateMarquee();

    const interval = setInterval(checkAndUpdateMarquee, 30000);

    return () => clearInterval(interval);
  }, []);

  const bgTakePrizeThadingyutTheme = isMobile
    ? bgTakePrizeThadingyut
    : bgTakePrizeThadingyutPc;

  const setItemProductActive = (id) => {
    navigate(`/mini-game/take-prize/${id}`);
  };

  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      return;
    }
    if (!id || id === "take-prize") {
      const dataSort = dataMiniGame.dataAwardListMini.sort(
        (a, b) => Number(a.rank) - Number(b.rank)
      );
      setItemProductActive(dataSort[0]?.id);
    }
  }, [dataMiniGame.dataAwardListMini]);

  // useEffect(() => {
  //   // dispatch(getDataPieceCollectedMiniGame(itemProductActive))
  // },[itemProductActive])

  const handleGetDataCollected = async () => {
    const dataApi = await getDataApi(API_PATH.miniGamePieceCollected, {
      award_id: itemProductActive,
    });
    setDataAwardActive(dataApi?.data);
    setIsRunout(dataApi?.is_runout);
  };

  useEffect(() => {
    handleGetDataCollected();
  }, [itemProductActive]);

  const handleShowDetailItem = (dataPrize) => {
    let awardName = "";
    const dataAwardListMini = dataMiniGame.dataAwardListMini || [];
    dataAwardListMini.forEach((item) => {
      if (+item.id === +dataPrize.minigame_award_id) {
        awardName = item.name;
      }
    });

    return dispatch(
      setOpenPopupPiece({
        isShowPopupPiece: true,
        type: TYPE_DETAIL_PUZZLE_PIECE,
        data: { ...dataPrize, awardName },
        turn: 0,
      })
    );
  };

  const handleClosePopupError = () => {
    dispatch(
      setDataPopupError({
        isOpen: false,
        message: "",
      })
    );
  };

  const handleGetText = () => {
    if (isRunout) {
      return t("mini_game.all_of_this_prize_have_been_claimed");
    }
    if (isTake) {
      return t("mini_game.your_puzzle_is");
    }
    return t("mini_game.prize_quantities_are_limited")
  };


  return (
    <>
      {dataMiniGame?.dataPopupErrorMini?.isOpen ? (
        <ModalNotifycation
          open={true}
          handleCancel={handleClosePopupError}
          title={t("error")}
          message={
            dataMiniGame?.dataPopupErrorMini?.message ||
            "လုပ်ဆောင်နေစဉ်ပြဿနာပေါ်လာပါတယ်။ ထပ်မံကြိုးစားပေးပါ။"
          }
          isContainer
        />
      ) : null}
      {dataMiniGame.popupPiece.isShowPopupPiece ? (
        <PopupCongPiece
          type={dataMiniGame.popupPiece.type}
          data={dataMiniGame.popupPiece.data}
        />
      ) : null}
      <Div
        bg={
          IS_EVENT_THADINGYUT_2025_THEME
            ? bgTakePrizeThadingyutTheme
            : IS_EVENT_NEW_YEAR_2025_THEME
            ? bgTakePrizeNewYear
            : bgTakePrize
        }
        className={`${
          IS_EVENT_THADINGYUT_2025_THEME
            ? "thadingyut-theme"
            : IS_EVENT_NEW_YEAR_2025_THEME
            ? "new-year-25-theme"
            : ""
        }`}
      >
        <Container className='container-thingyan container-minigame'>
          <div className='thingyan-home-header'>
          {IS_EVENT_NEW_YEAR_2025_THEME && (
            <SnowfallContainer>
              <Snowfall
                snowflakeCount={maxSnowCountMobile}
                radius={[0.5, 3.0]}
                speed={[0.5, 1]}
                wind={[-0.5, 1]}
              />
            </SnowfallContainer>
          )}
            {!IS_EVENT_THADINGYUT_2025_THEME &&
              !IS_EVENT_NEW_YEAR_2025_THEME && (
                <>
                  <img src={iconBg1} alt='' className='icon-bg-web1' />
                  <img src={iconBg2} alt='' className='icon-bg-web2' />
                </>
              )}
            <div className='header-take-prize'>
              <HeaderAction newYearAudioRef={newYearAudioRef} />
            </div>
            <Tab itemProductActive={itemProductActive} />
            <ListProduct
              setItemProductActive={setItemProductActive}
              itemProductActive={itemProductActive}
            />
            <DetailProduct
              itemProductActive={itemProductActive}
              dataAwardActive={dataAwardActive}
              setDataAwardActive={setDataAwardActive}
              handleShowDetailItem={handleShowDetailItem}
              isRunout={isRunout}
              setIsTake={setIsTake}
            />
            <div className='content-take-prize-minigame'>{handleGetText()}</div>
          </div>
        </Container>
        {showInviteMarquee && <InviteMarquee />}
      </Div>
      {dataMiniGame.popupPuzzle.isShow ? (
        <PopupCongratulaPuzzle isOpen={dataMiniGame.popupPuzzle.isShow} />
      ) : null}
    </>
  );
}
const Div = styled.div`
  /* new */
  .container-thingyan .thingyan-home-header {
    background-image: url(${(props) => props.bg}) !important;
  }
  /* end new */
  .img-filter-event__2025 {
    filter: drop-shadow(0px 0px 1px white) drop-shadow(0px 0px 1px white)
      drop-shadow(0px 0px 2px white);
  }

  .text-default {
    -webkit-text-stroke: inherit !important;
    font-size: 26px !important;
  }

  &.thadingyut-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

      /* @media (min-width: 768px) and (max-width: 1400px) {
        background-size: 165% 100%;
      }

      @media (min-width: 1400px) and (max-width: 1600px) {
        background-size: 145% 100%;
      } */
    }
  }

  &.new-year-25-theme {
    .container-thingyan .thingyan-home-header {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }

    @media (min-width: 768px) and (max-width: 1400px) {
      background-size: 165% 100%;
    }

    @media (min-width: 1400px) and (max-width: 1600px) {
      background-size: 145% 100%;
    }
  }
`;

const Container = styled.div`
  .header-take-prize {
    padding-top: 18px;
    margin-bottom: 30px;
  }

  .content-take-prize-minigame {
    background-color: rgba(0, 0, 0, 0.4);
    padding: 10px;
    border-radius: 40px;
    color: white;
    font-style: italic;
    text-align: center;
    margin: 0 85px;
    margin-bottom: 20px;

    @media (max-width: 1400px) {
      margin: 0 36px;
      margin-bottom: 20px;
    }

    @media (max-width: 440px) {
      margin: 0 8px;
      margin-bottom: 20px;
    }
  }

  .thingyan-home-header {
    overflow-y: hidden;
  }

  @media (max-width: 576px) {
    .header-take-prize {
      padding-top: 10px;
      margin-bottom: 20px;
    }
  }

  @media (min-width: 1400px) {
    .header-take-prize {
      padding-top: 25px;
      padding-left: 22px;
      padding-right: 22px;
    }
  }
`;

const SnowfallContainer = styled.div`
  height: 100%;
  width: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
`;
